import React, { useState } from 'react';
import { Card, CardBody, Button, Alert } from 'reactstrap';
import { useSelector } from 'react-redux';
import { selectCountry } from '../../selectors/country';

const CreateTokenForm = ({ countryId, onTokenCreated, onCancel }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');

  const country = useSelector(selectCountry(countryId));

  const handleCreateToken = async () => {
    if (!countryId) {
      setError('Country ID not available');
      return;
    }

    setIsCreating(true);
    setError('');

    try {
      // Open OAuth flow for selected country
      const authUrl = `${process.env.REACT_APP_WS_FUNCTION_URL}/facebook/auth/${countryId}`;

      const popup = window.open(
        authUrl,
        'facebook-oauth',
        'width=600,height=700,scrollbars=yes,resizable=yes',
      );

      // Monitor popup closure
      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed);
          setIsCreating(false);
          // Notify that token has been created
          onTokenCreated();
        }
      }, 1000);
    } catch (error) {
      console.error('Error creating token:', error);
      setError('Error creating token. Please try again later.');
      setIsCreating(false);
    }
  };

  return (
    <Card>
      <CardBody>
        <h5 className="mb-3">🆕 Create New Facebook Token</h5>

        {error && (
          <Alert color="danger" className="mb-3">
            {error}
          </Alert>
        )}

        <p className="text-muted mb-3">
          You are about to create a Facebook token for country{' '}
          <strong>{country.name}</strong>. A window will be opened to authorize
          the application via Facebook OAuth.
        </p>

        {!countryId && (
          <Alert color="warning" className="mb-3">
            <i className="bx bx-error mr-1"></i>
            No country selected in Dashboard. Please select a country before
            creating a token.
          </Alert>
        )}

        <div className="d-flex gap-2">
          <Button
            color="primary"
            onClick={handleCreateToken}
            disabled={isCreating || !countryId}
            className="mr-2">
            {isCreating ? (
              <>
                <i className="bx bx-loader bx-spin mr-1"></i>
                Creating...
              </>
            ) : (
              <>
                <i className="bx bx-plus mr-1"></i>
                Create Token
              </>
            )}
          </Button>

          {onCancel && (
            <Button
              color="secondary"
              outline
              onClick={onCancel}
              disabled={isCreating}>
              Cancel
            </Button>
          )}
        </div>

        <div className="mt-3">
          <small className="text-muted">
            <i className="bx bx-info-circle mr-1"></i>
            You will need to authorize the application via Facebook to complete
            token creation.
          </small>
        </div>
      </CardBody>
    </Card>
  );
};

export default CreateTokenForm;
